import styled from '@mui/material/styles/styled'
import MuiTextField from '@mui/material/TextField'
export const TextField = styled(MuiTextField, {
  name: 'TextField',
  slot: 'Root',
  skipSx: true,
})`
  span {
    width: 100%;
    overflow: hidden;
  }
`
